import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-videopage',
  templateUrl: './videopage.component.html',
  styleUrls: ['./videopage.component.css']
})
export class VideopageComponent implements OnInit, AfterViewInit {
  videourl;
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(qParam => {
      this.videourl = '../../../../../assets/helpvideos/' + decodeURI(qParam.url);
    });
  }

  ngAfterViewInit() {
    if (localStorage.getItem('reloaded')) {
      localStorage.removeItem('reloaded');
    } else {
      localStorage.setItem('reloaded', "true");
      //this.loadVideo();
    }
  }

  loadVideo() {
    location.reload();
  }

  

}
